/* ================================================== */
/* CHECK BROWSER
/* ================================================== */

$(document).ready(function() {
	$('html').attr('data-browser-name', $.ua.browser.name.toLowerCase());
	$('html').attr('data-browser-version', $.ua.browser.major);
});